module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-blue.5d912fd4.svg";